import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69d973d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-gray-700" }
const _hoisted_2 = { class: "text-lg font-medium p-3 border-b" }
const _hoisted_3 = { class: "w-full overflow-y-auto hl-hv-ct" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HistoryCard = _resolveComponent("HistoryCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('common.versionHistory')), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.historyList, (item, index) => {
        return (_openBlock(), _createBlock(_component_HistoryCard, {
          item: item,
          selectedVersion: _ctx.state.selectedVersion,
          count: _ctx.state.count,
          key: index,
          onClick: ($event: any) => (_ctx.switchPreview(item))
        }, null, 8, ["item", "selectedVersion", "count", "onClick"]))
      }), 128))
    ])
  ]))
}